module.exports = "agm-map {\n    height: 460px;\n}\n\n.bottom-20{\n  margin-bottom: 20px;\n}\n\n.church-image-map{\n  width: 100%;\n}\n\n.church-pointer-map{\n  cursor: pointer;\n}\n\n.padding-50{\n  padding: 50px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/iglesias/mapa-iglesias/mapa-iglesias.component.css
// module id = ./src/app/admin/pages/iglesias/mapa-iglesias/mapa-iglesias.component.css
// module chunks = main